/*
 * Allowed file types for the offline cache.
 */
type IFileType = 'javascript' | 'css' | 'video';
export default IFileType;

export const VIFileType = ['javascript', 'css', 'video'];
